import NanoPopup from "../../components/Popups/NanoPopup";
import Paywall from "./Paywall";
import FamilySubscriptionPopup from "../../Family/Babillard/Popups/FamilySubscriptionPopup";

export default class PaywallPopupFactory {
  public Create(): NanoPopup {
    if ($("#family-sub-required-popup").length > 0) {
      return new FamilySubscriptionPopup();
    }

    return new NanoPopup({
      target: ".js-paywall-popup",
      isPaywall: true,
      willOpen: () => {
        if (Paywall.instance.currentlyDisplayedPopup) {
          Paywall.instance.currentlyDisplayedPopup.Hide(false, true, true);
        }
      },
      onHide: () => {
        if (Paywall.instance.currentlyDisplayedPopup) {
          Paywall.instance.currentlyDisplayedPopup.Show();
        }
      },
    });
  }
}
